import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  productName: yup.string().required("Product name is required"),
  productSku: yup.string().nullable(true),
  categories: yup
    .array()
    .of(yup.string().required())
    .min(1, "At least one category is required")
    .required("Category is required"),
  stores: yup
    .array()
    .min(1, "Minimum of one store is required")
    .required("Minimum of one store is required"),
  hasVariants: yup.boolean(),

  additionalUnit: yup.array().of(
    yup.object().shape({
      value: yup
        .number()
        .typeError("value must be a number")
        .required("Unit equivalent value is required"),
      unit: yup.string().required("Unit is required"),
    }),
  ),
  storeProperties: yup.array().when("hasVariants", {
    is: false,
    then: yup.array().of(
      yup.object().shape({
        cost_price: yup
          .number()
          .typeError("Cost price must be a number")
          .required("Cost price is required"),
        minimum_stock_quantity: yup.mixed().optional(),
        rebate: yup.mixed().optional(),
        stock_quantity: yup.mixed().optional(),
        pricings: yup.array().of(
          yup.object().shape({
            price: yup
              .number()
              .typeError("Selling price must be a number")
              .required("Selling price is required"),
            pricing_type_id: yup
              .string()
              .nullable()
              .required("Pricing type is required"),
          }),
        ),
      }),
    ),
  }),

  variantProperties: yup
    .array()
    .when("hasVariants", {
      is: true,
      then: yup.array().of(
        yup.object().shape({
          option: yup.string().required("Option is required"),
          value: yup.string().required("Value is required"),
          store_properties: yup.array().of(
            yup.object().shape({
              cost_price: yup
                .number()
                .typeError("Cost price must be a number")
                .required("Cost price is required"),
              minimum_stock_quantity: yup.mixed().optional(),
              rebate: yup.mixed().optional(),
              stock_quantity: yup.mixed().optional(),
              pricings: yup.array().of(
                yup.object().shape({
                  price: yup
                    .number()
                    .typeError("Selling price must be a number")
                    .required("Selling price is required"),
                  pricing_type_id: yup
                    .string()
                    .nullable()
                    .required("Pricing type is required"),
                }),
              ),
            }),
          ),
        }),
      ),
    })
    .required(),
});

export const Validation = ({
  rootFormDetails,
  storeProperties,
  variantProperties,
  additionalUnit,
}) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      productName: rootFormDetails.product_name,
      productSku: rootFormDetails.sku,
      categories: rootFormDetails.categories,
      stores: rootFormDetails.stores,
      hasVariants: rootFormDetails.has_variant,
      storeProperties,
      variantProperties,
      additionalUnit,
    },
  });
};
